<template>
  <Modal :title="lc.title" :icon="lc.icon" maxWidth="720" v-model="visible" @backdrop="closeModal">
    <template #activator="{ on, attrs }">
        <Button
          :label="lc.buttonLabel"
          color="primary"
          v-bind="attrs"
          v-on="on"
        />
    </template>
    <Row>
      <Col cols="12">
        <p class="text-paragraph-2">{{ lc.subtitle }} </p>
      </Col>
      <ListItem :title="lc.listItems.knowHow">
        <KnowHow />
      </ListItem>
      <ListItem :title="lc.listItems.helpTable">
        <HelpTable />
      </ListItem>
      <ListItem :title="lc.listItems.spread">
        <PropagationInfo />
      </ListItem>
    </Row>
    <template #append>
      <Button
        color="primary"
        v-text="lc.closeLabel"
        @click="closeModal"
      />
    </template>
  </Modal>
</template>

<script>
import { Button, Modal, Col, Row } from '@locaweb/design-system-vue'
import KnowHow from './DNSModal/KnowHow.vue'
import ListItem from './DNSModal/ListItem.vue'
import HelpTable from './DNSModal/HelpTable.vue'
import PropagationInfo from './DNSModal/PropagationInfo.vue'

export default {
  name: 'DNSModal',
  components: {
    Modal,
    Col,
    Row,
    Button,
    KnowHow,
    ListItem,
    HelpTable,
    PropagationInfo
  },
  data: () => ({
    visible: false
  }),
  computed: {
    lc () {
      return this.$lc('domains.addDomain.domainStatus.domain_not_configured.modal')
    }
  },
  methods: {
    closeModal () {
      this.visible = false
    }
  }
}
</script>
